<div class="card">
    <div class="card-header">
        <div>
            <button class="btn btn-light btn-xs" (click)="expanded = !expanded">
                @if (expanded) {
                <span class="dripicons-chevron-up"></span>
                }
                @if (!expanded) {
                <span class="dripicons-chevron-down"></span>
                }
            </button>
            {{ words[language][ 'Reconditioning Cost' ] }}
        </div>
        <div class="text-right"><strong>{{reconCostTotal | currency}}</strong></div>
    </div>
    @if (expanded) {
    <div class="card-body">
        <ul id="recon-costs" class="list-group">
            @for (recon of reconCosts; track recon.id) {
                <li class="list-group-item">
                    <p (click)="setInformation(recon)">{{recon.dateIncurred | date:'MMM dd, yy' | uppercase}}</p>
                    <p (click)="setInformation(recon)"><span class="material-icons">{{iconify(recon.type)}}</span></p>
                    <div (click)="setInformation(recon)">
                        <p>{{recon.reconditioningDescription.description}}</p>
                        <p class="subtitle">{{recon.type | lowercase}}</p>
                    </div>
                    <div (click)="setInformation(recon)">
                        <p>{{recon.contact.name}}</p>
                        <p class="subtitle">{{formatPhone(recon.phoneNumber)}}</p>
                    </div>
                    <p class="text-right" (click)="setInformation(recon)">{{recon.costIncurred | currency}}</p>
                    <div (click)="setInformation(recon)">
                        @if (recon.datePaid) {
                            <p>{{recon.datePaid | date:'MMM d, yyyy'}}</p>
                            <p class="subtitle text-truncate">{{recon.checkNumber}} {{recon.referenceNumber}}</p>
                        }
                        @else {
                            <p>Not yet paid</p>
                        }
                    </div>
                    <div class="actions">
                        <button class="btn btn-sm btn-link" data-toggle="modal" data-target="#deleteReconCostModal" (click)="setId($event, recon.id, recon.costIncurred)"><span class="dripicons-trash text-danger"></span></button>
                    </div>
                </li>
            }
        </ul>
    </div>
    <div class="card-footer">
        <div class="row">
            <form class=" col-lg col-xs-12" [formGroup]="information">
                <div class="form-row">
                    <div class="form-group col">
                        <label for="dateIncurred">Date Incurred</label>
                        <input name="dateIncurred" id="dateIncurred" formControlName="dateIncurred" type="date" class="form-control form-control-sm">
                    </div>
                    <div class="form-group col">
                        <label for="type">Type</label>
                        <select name="type" id="type" formControlName="type" class="form-control form-control-sm">
                            @for (reconType of reconTypes; track reconType) {
                                <option [value]="reconType">{{reconType | titlecase}}</option>
                            }
                        </select>
                    </div>
                    <div class="form-group col">
                        <label for="descriptionId">Description</label>
                        <select name="descriptionId" id="descriptionId" formControlName="descriptionId" class="form-control form-control-sm">
                            @for (desc of descriptions; track desc) {
                                <option [value]="desc.id">
                                    {{desc.description}} - {{desc.type}}
                                </option>
                            }
                        </select>
                    </div>
                    <div class="form-group col">
                        <label for="costIncurred">Cost Incurred</label>
                        <currency-input [id]="'costIncurred'" [control]="information.get('costIncurred')"></currency-input>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col">
                        <contact-advanced-search type="vendor" [contactIdSaved]="information.get('vendorId').value" (setContactId)="setContactIdEvent($event)"></contact-advanced-search>
                    </div>
                    <div class="form-group col">
                        <label for="phoneNumber">Phone Number</label>
                        <input name="phoneNumber" id="phoneNumber" formControlName="phoneNumber" type="tel" class="form-control form-control-sm">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col">
                        <label for="datePaid">Date Paid</label>
                        <input name="datePaid" id="datePaid" formControlName="datePaid" type="date" class="form-control form-control-sm">
                    </div>
                    <div class="form-group col">
                        <label for="checkNumber">Check Number</label>
                        <input name="checkNumber" id="checkNumber" formControlName="checkNumber" type="text" class="form-control form-control-sm">
                    </div>
                    <div class="form-group col">
                        <label for="referenceNumber">Reference Number</label>
                        <input name="referenceNumber" id="referenceNumber" formControlName="referenceNumber" type="text" class="form-control form-control-sm">
                    </div>
                </div>
                @if (inventoryId !== 0) {
                <div class="button-bar">
                    <button class="btn btn-link btn-sm" id="btn-reset" (click)="resetInformation()"><span class="text-danger">cancel</span></button>
                    <button class="btn btn-success btn-sm" id="btn-save" (click)="saveReconCost()">Save</button>
                </div>
                }
            </form>
            <div class="col-lg-3 col-xs-12">
                <ul id="group-totals" class="list-group">
                    @for (group of groupKeys; track group) {
                        <li class="list-group-item">
                            <p>{{group | titlecase}}</p>
                            <p class="text-right">{{reconCostTotals[group].amount | currency}}</p>
                        </li>
                    }
                    <li class="list-group-item total">
                        <p>Total</p>
                        <p class="text-right">{{reconCostTotal | currency}}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    }
</div>


<!-- modals -->
<!-- delete modal -->
<div class="modal fade" id="deleteReconCostModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h4 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h4>
                <span class="text-dark my-3 text-center">Are you sure you want to delete this reconditioning
                    cost?</span>
                <button class="btn btn-danger mt-2" (click)="deleteReconCost()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete-reconCost">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->